import { createFileRoute } from "@tanstack/react-router";
import {
	formTabSearch,
	redirectLegacyEntityTypeForm,
} from "@/features/form-editor/lib/redirect-legacy-entity-type-form";

const ROUTE_ID =
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/ticketTypes/$ticketTypeId/full/form" as const;

export const Route = createFileRoute(ROUTE_ID)({
	beforeLoad: ({ location, params, search }) => {
		redirectLegacyEntityTypeForm({
			pathname: location.pathname,
			typeId: params.ticketTypeId,
			to: "/org-admin/$orgId/configuration/ticketTypes/$ticketTypeId/full",
			params: { orgId: params.orgId, ticketTypeId: params.ticketTypeId },
			search: formTabSearch(search),
		});
	},
	component: () => null,
});
